import { Link } from "react-router-dom";

export const HeroKitCard = ({ className = "", testId }) => (
  <Link
    to="/starter-kit"
    data-testid={testId}
    aria-label="See the Starter Kit: sample Basketball 7-9 practice card"
    className={`group block ${className}`}
  >
    <div className="relative rotate-[4deg] group-hover:rotate-[1deg] group-hover:-translate-y-1 transition-transform duration-300 shadow-[0_24px_60px_rgba(0,0,0,0.55)] bg-white">
      <img src="/starter-kit-sample-card-7-9.webp" alt="Sample Starter Kit practice card: Basketball 7-9, 60-minute Plan A" className="block w-full h-auto" loading="eager" />
      <span data-testid={`${testId}-tag`} className="absolute -top-3 -left-3 bg-[color:var(--vt-amber)] text-[color:var(--vt-dark)] font-head text-sm tracking-wide px-3 py-1 -rotate-[4deg]">
        SAMPLE CARD
      </span>
    </div>
    <p className="mt-4 mx-auto w-fit text-xs text-[color:var(--vt-white)] bg-[color:var(--vt-dark)]/80 px-2 py-1 text-center">Basketball 7-9 · 60-min Plan A · one of the cards in your $9 kit</p>
  </Link>
);
